function showToast(icon, title) {
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
        },
    });

    Toast.fire({
        icon: icon,
        title: title,
    });
}

// FUNCAO NUMERO MULTIPLO
function NumeroMultiplo(num, multi) {
    if (num < multi || num === 0) {
        // se menor que multiplo ou igual a zero
        return multi;
    } else if (num % multi === 0) {
        // se for multiplo
        return num;
    } else {
        // se nao for multiplo
        var ai = 1;
        var bi = 1;
        for (var a = num; a > multi; a--) {
            if (a % multi === 0) break;
            ai++;
        }
        for (var b = num; b > multi; b++) {
            if (b % multi === 0) break;
            bi++;
        }
        if (ai === bi) {
            return b;
        } else if (ai > bi) {
            return b;
        } else {
            return b; // modificado para sempre arredondar para cima
            //return a;
        }
    }
}

// BLUR FATOR DE CONVERSAO LOGISTICA
$(document).on("blur", ".qtde-lista", function () {
    var val = parseInt($(this).val());
    var mul = parseInt($(this).attr("data-multi"));
    var allowMultiplo = $(this).attr("data-allow-multi");
    if (allowMultiplo == "S") {
        mul = val > 24 ? 24 : mul;
    } else {
        mul = 1;
    }
    var res = NumeroMultiplo(val, mul);
    console.log(res);
    if (!isNaN(res) && val != 0) {
        $(this).val(res);
    } else {
        $(this).val("");
    }
});

//ADD PRODUTO NO CARRINHO
$(document).on("click", ".btnAddCarrinho", function (e) {
    e.preventDefault();
    var form = $(this).attr("data-codigo");
    var refresh = $(this).attr("data-refresh");
    var qtde = $(".FormProduto" + form).find(".qtde-lista");
    var totalqtde = 0;
    qtde.each(function () {
        var num_qtde = $(this).val() == "" ? 0 : $(this).val();
        totalqtde = totalqtde + parseInt(num_qtde);
    });

    $(".FormProduto" + form)
        .find(".descExtraMova")
        .keyup();
    if (parseInt(totalqtde) > 0) {
        $.ajax({
            type: "POST",
            data: $(".FormProduto" + form).serialize(),
            url: "ajax/ajax-add-carrinho.php",
            dataType: "json",
            context: this,
            success: function (resultado) {
                showToast(resultado.tipo, resultado.mensagem);
                $(".infosCarrinho .qtdItens").html(resultado.qtde_total);
                $(this).closest(".cardCompra").removeClass("showElement");
                $(this).html("Alterar a quantidade");
                console.log(refresh);
                if (refresh == "S") {
                    location.reload();
                }
                if (resultado.val_total > 0) {
                    // modalPromo(resultado.val_total);
                }
            },
        });
    }
});

//ALTERA PRODUTO NO CARRINHO
$(document).on("click", ".btnUpdCarrinho", function (e) {
    e.preventDefault();
    var id = $(this).attr("data-codigo");
    $.ajax({
        type: "POST",
        data: { qtde: $(this).val(), id: id },
        url: "ajax/ajax-upd-carrinho.php",
        dataType: "json",
        context: this,
        success: function (resultado) {
            showToast(resultado.tipo, resultado.mensagem);
        },
    });
});

//REMOVE PRODUTO NO CARRINHO
$(document).on("click", ".btn-remove-item-cart", function (e) {
    e.preventDefault();
    var produto = $(this).attr("data-cod-produto");
    $.ajax({
        type: "POST",
        data: { MM_acao: "DelItemCart", produto: produto },
        url: "ajax/ajax-del-carrinho.php",
        dataType: "json",
        context: this,
        success: function (resultado) {
            showToast(resultado.tipo, resultado.mensagem);
            location.href = "meu-carrinho";
        },
    });
});

//REMOVE GRUPO NO CARRINHO
$(document).on("click", ".btn-remove-grupo-cart", function (e) {
    e.preventDefault();
    var grupo = $(this).attr("data-cod-grupo");
    $.ajax({
        type: "POST",
        data: { MM_acao: "DelGrupoCart", grupo: grupo },
        url: "ajax-del-carrinho.php",
        dataType: "json",
        context: this,
        success: function (resultado) {
            showToast(resultado.tipo, resultado.mensagem);
            location.href = "meu-carrinho";
        },
    });
});

$(document).on("keyup", ".qtde-lista", function (e) {
    e.preventDefault();
    var oldval = $(this).val();
    var form = $(this).closest("form");
    var preco = parseFloat(form.find(".preco-lista").val());
    var qtde = form.find(".qtde-lista");
    var totalqtde = 0;
    var num_qtde;
    qtde.each(function () {
        var num_qtde = $(this).val() == "" ? 0 : $(this).val();
        totalqtde = totalqtde + parseInt(num_qtde);
    });
    form.find(".descExtraMova").keyup();
});

$(document).on("blur", ".descExtraMova", function () {
    var valor = parseFloat($(this).val());
    var index = $(this).attr("data-index");
    var form = $(this).attr("data-form");

    if (isNaN(valor)) valor = 0;

    var form2 = $(this).closest("form");
    //var qtde = form2.find(".qtde-lista");
    //var totalqtde = 0;
    //qtde.each(function () {
    //    var num_qtde = $(this).val() == "" ? 0 : $(this).val();
    //    totalqtde = totalqtde + parseInt(num_qtde);
    //});

    //if (totalqtde > 0) {
        $("#btn" + index).prop("disabled", true);
        $.ajax({
            type: "POST",
            data: $("." + form).serialize(),
            url: "ajax/ajax-aplica-desconto.php?2",
            success: function (itens) {
                var arr = itens.split("|");
                var valPor = parseFloat(arr[0]).toFixed(2);
                var descMed = parseFloat(arr[1]).toFixed(2);
                var descMax = parseFloat(arr[3]);
                var descHight = arr[4];
                var descNegativoError = arr[7];
                var saldo = parseFloat(arr[5]).toFixed(2);
                console.log(valPor, descMed, descMax, 1111);

                if (descHight === "N") {
                    showToast('warning', "O desconto máximo concedido é de " + descMax + "%");
                    $("#desconto_extra" + index).val(descMax);
                }
                if (descNegativoError === "S") {
                    showToast('warning', "O valor com desconto não pode ser maior que o preço fábrica.");
                }

                form2.find("input.desc_medio").val(arr[1]);

                if (!isNaN(valPor)) {
                    form2.find("input.preco-lista").val(valPor);
                    $('#ValorPor' + index).html('R$ ' + valPor.replace(".", ","));
                }

                setTimeout(function () {
                    $("#btn" + index).prop("disabled", false);
                }, 3000);
            },
        });
    //} else {
    //    showToast('warning', "A quantidade não foi informada");
    //}
});

$(document).on("click", "#btnRecuperaLogin", function (e) {
    e.preventDefault();
    $("#recupera-login").addClass("active");
});

$(document).on("click", ".btn-close", function (e) {
    e.preventDefault();
    $("#recupera-login").removeClass("active");
});

$(document).on("click", "#btn-envia-email", function (e) {
    e.preventDefault();
    Swal.fire({
        title: "Aguarde!",
        html: "Enviando e-mail de recuperação de senha.",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        },
    });
    $.ajax({
        type: "POST",
        data: $("#formEnviaSenha").serialize(),
        url: $("#formEnviaSenha").attr("action"),
        context: this,
        success: function (response) {
            response = response.split("|");
            Swal.fire({
                icon: response[1],
                title: response[2],
                text: response[3],
                confirmButtonColor: "#2ca4c6",
                allowEscapeKey: false,
                allowOutsideClick: false,
            }).then((result) => {
                if (response[1] == "success") location.href = "login";
            });
        },
    });
});

$(document).on("click", "#btn-login", function (e) {
    e.preventDefault();
    Swal.fire({
        title: "Aguarde!",
        html: "Validando suas credenciais.",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        },
    });
    $.ajax({
        type: "POST",
        data: $("#formAutenticacao").serialize(),
        url: $("#formAutenticacao").attr("action"),
        context: this,
        success: function (response) {
            response = response.split("|");
            if (response[1] == "success") {
                Swal.fire({
                    icon: response[1],
                    title: response[2],
                    text: response[3],
                    showDenyButton: false,
                    showCancelButton: false,
                    showCloseButton: false,
                    showConfirmButton: false,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
                location.href = response[4];
            } else {
                Swal.fire({
                    icon: response[1],
                    title: response[2],
                    text: response[3],
                    confirmButtonColor: "#2ca4c6",
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (response[1] == "info") location.href = response[4];
                });
            }
        },
    });
});

const input = document.getElementById("buscaCliente");
if (input) {
    const lista = document.querySelectorAll(".select-clientes li");

    function normalizar(texto) {
        return texto
            .toLowerCase()
            .normalize("NFD") // separa acentos
            .replace(/[\u0300-\u036f]/g, "") // remove acentos
            .replace(/[^a-z0-9\s]/g, ""); // remove caracteres especiais
    }

    input.addEventListener("input", () => {
        const termo = normalizar(input.value);

        lista.forEach((li) => {
            const textoLi = normalizar(li.textContent);

            if (textoLi.includes(termo)) {
                li.style.display = "";
            } else {
                li.style.display = "none";
            }
        });
    });

    $(document).on("click", "#btn-set-cliente", function (e) {
        e.preventDefault();
        Swal.fire({
            title: "Aguarde!",
            html: "Validando suas credenciais.",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });
        $.ajax({
            type: "POST",
            data: $("#formAutenticacaoCliente").serialize(),
            url: $("#formAutenticacaoCliente").attr("action"),
            context: this,
            success: function (response) {
                response = response.split("|");
                if (response[1] == "success") {
                    Swal.fire({
                        icon: response[1],
                        title: response[2],
                        text: response[3],
                        showDenyButton: false,
                        showCancelButton: false,
                        showCloseButton: false,
                        showConfirmButton: false,
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading();
                        },
                    });
                    location.href = response[4];
                } else {
                    Swal.fire({
                        icon: response[1],
                        title: response[2],
                        text: response[3],
                        confirmButtonColor: "#2ca4c6",
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (response[1] == "info") location.href = response[4];
                    });
                }
            },
        });
    });
}

// Confirma pedidos pelo cliente
$(document).on("click", "#btn-confirma-pedido", function (e) {
    e.preventDefault();
    Swal.fire({
        icon: "question",
        title: "Tem certeza de que deseja CONFIRMAR este pedido?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Confirmar",
        denyButtonText: "Fechar",
        confirmButtonColor: "#2ca4c6",
        allowEscapeKey: false,
        allowOutsideClick: false,
    }).then((result) => {
        if (result.isConfirmed) {
            $.ajax({
                type: "GET",
                url: $("#btn-confirma-pedido").attr("href"),
                context: this,
                success: function (response) {
                    location.reload();
                },
            });
        }
    });
});

// Confirma pedidos pelo cliente
$(document).on("click", "#btn-cancelar-pedido", function (e) {
    e.preventDefault();
    Swal.fire({
        icon: "question",
        title: "Tem certeza de que deseja CANCELAR este pedido?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Cancelar",
        denyButtonText: "Fechar",
        confirmButtonColor: "#2ca4c6",
        allowEscapeKey: false,
        allowOutsideClick: false,
    }).then((result) => {
        if (result.isConfirmed) {
            $.ajax({
                type: "GET",
                url: $("#btn-cancelar-pedido").attr("href"),
                context: this,
                success: function (response) {
                    location.reload();
                },
            });
        }
    });
});

$(document).on("click", "#criar-senha", function (e) {
    e.preventDefault();
    Swal.fire({
        title: "Aguarde!",
        html: "Estamos salvando sua nova senha.",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        },
    });
    $.ajax({
        type: "POST",
        data: $("#formCriarSenha").serialize(),
        url: $("#formCriarSenha").attr("action"),
        context: this,
        success: function (response) {
            response = response.split("|");
            Swal.fire({
                icon: response[1],
                title: response[2],
                text: response[3],
                confirmButtonColor: "#174275",
                allowEscapeKey: false,
                allowOutsideClick: false,
            }).then((result) => {
                if (response[1] == "success") location.href = "login";
            });
        }
    });
});
